export const averageMonthlyCost = (a, b) => {
    if (a && a.data && !a.data.projection)
        return 1;
    if (b && b.data && !b.data.projection)
        return -1;
    return a.data.projection.paymentValue > b.data.projection.paymentValue
        ? 1
        : -1;
};
export const averageYearlyCost = (a, b) => {
    if (a && a.data && !a.data.projection)
        return 1;
    if (b && b.data && !b.data.projection)
        return -1;
    return a.data.projection.annualBill > b.data.projection.annualBill ? 1 : -1;
};
export const averageYearlySavings = (a, b) => {
    if (a && a.data && !a.data.projection)
        return 1;
    if (b && b.data && !b.data.projection)
        return -1;
    return a.data.projection.estimatedSaving > b.data.projection.estimatedSaving
        ? -1
        : 1;
};
